/**
 * @file Base class for game states.
 *
 * A state decides WHAT runs each frame; it never implements gameplay itself.
 * `PlayingState` ticks the world, `PausedState` does not — that single
 * difference is the whole point of the pattern.
 */

export class GameState {
  /**
   * @param {import('../Context.js').GameContext} ctx Shared game context.
   * @param {import('./StateMachine.js').StateMachine} machine Owning machine.
   */
  constructor(ctx, machine) {
    /** @type {import('../Context.js').GameContext} */
    this.ctx = ctx;
    /** @type {import('./StateMachine.js').StateMachine} */
    this.machine = machine;
  }

  /**
   * Called when the state becomes active.
   * @param {any} [_payload] Data forwarded by the transition.
   * @returns {void}
   */
  enter(_payload) {}

  /**
   * Called when the state stops being active.
   * @returns {void}
   */
  exit() {}

  /**
   * Per-frame tick.
   * @param {number} _dt Delta time in seconds.
   * @returns {void}
   */
  update(_dt) {}
}
